import { useState } from "react";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import Dashboard from "./Dashboard";
import SitemapGroups from "./SitemapGroups";
import WordpressSync from "./WordpressSync";
import SitemapLogs from "./SitemapLogs";
import SitemapUrls from "./CustomUrls/Urls";

export default function Sitemap() {
  const [tab, setTab] = useState(0);

  const renderTab = () => {
    switch (tab) {
      case 0:
        return <Dashboard />;
      case 1:
        return <SitemapGroups />;
      case 2:
        return <SitemapUrls />;
      case 3:
        return <WordpressSync />;
      case 4:
        return <SitemapLogs />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}

      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 3,
          border: "1px solid #e5e7eb",
          background:
            "linear-gradient(135deg,#ffffff,#f8fafc)",
          mb: 3,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <Typography
              variant="h4"
              fontWeight={700}
            >
              Sitemap Management
            </Typography>

            <Typography
              color="text.secondary"
              mt={1}
            >
              Manage sitemap groups, custom URLs,
              WordPress synchronization and activity
              logs.
            </Typography>
          </Box>

          {/* <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
          >
            Refresh
          </Button> */}
        </Stack>
      </Paper>

      {/* Navigation */}

      <Paper
        elevation={0}
        sx={{
          mb: 3,
          p: 1,
          borderRadius: 3,
          border: "1px solid #e5e7eb",
        }}
      >
        <Tabs
          value={tab}
          onChange={(e, value) =>
            setTab(value)
          }
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{
            sx: {
              display: "none",
            },
          }}
        >
          {[
            "Dashboard",
            "Groups",
            "URLs",
            "WordPress Sync",
            "Logs",
          ].map((label, index) => (
            <Tab
              key={label}
              label={label}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                minHeight: 44,
                mx: 0.5,
                fontWeight: 600,

                "&.Mui-selected": {
                  bgcolor: "primary.main",
                  color: "#fff",
                },
              }}
            />
          ))}
        </Tabs>
      </Paper>

      {/* Content */}

      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          border: "1px solid #e5e7eb",
          minHeight: "70vh",
        }}
      >
        {renderTab()}
      </Paper>
    </Box>
  );
}